import React from 'react';
import {useState, useEffect} from 'react';
import './Cart.scss';
import {CartManager} from './CartManager';
import {SiteOrder} from '../../FW/Models/SiteOrder';

const Cart = function Cart(props) {
  const [minimized, setMinimized] = useState(false);
  const minimize = () => {
    setMinimized(!minimized);
  }
  const [cartItems, setCartItems] = useState(0);

  useEffect(() => {
    FWCartEvents.on('change', () => {
      setCartItems((c) =>{
        return c + 1;
      });
    });

    const order = CartManager.getOrder();
    if (order) {
      // check to see if it's paid
      const o = SiteOrder.findOrCreate({id: order.id});
      o.ensureLoaded().then((r) => {
        if (typeof r.get('paid_at') !== 'undefined' && r.get('paid_at') !== null) {
          CartManager.reset();
          setCartItems(cartItems + 1);
        }
      });
    }
  }, []);

  const products = CartManager.getSelectedProducts();

  const p = products.map(function(product) {
    return <div style={{textAlign: 'left', display: 'grid', gridTemplateColumns: '1fr 4fr 1fr'}} key={product.productId}>
      <div style={{height: 50, background: 'url(' + product.image + ')', backgroundSize: 'cover', backgroundPosition: 'center', display: 'inline-block'}}></div>
      <div style={{
        display: 'inline-block',
        height: 40,
        padding: 5
      }}>
        {product.productName}
      </div>
      <div>
        <div style={{padding: 10}}>
          {CartManager.showQuantity(product) ? <input type="text" value={product.qty} size={2} onChange={(e)=>{
            CartManager.updateQuantity(product.productId, e.target.value);
          }} /> : null}
          <span style={{cursor: 'pointer'}} className="fa fa-trash" onClick={CartManager.removeProduct.bind(this, product.productId)}></span>
        </div>
      </div>
    </div>
  });

  return p.length > 0 ? <div className="cart-wrapper" style={{width: minimized ? 'auto' : null}}>
    <div className="cart-header">
      {!minimized ? <div>
        <span className="header-text">Cart</span>
        <span className="cart-bar" onClick={minimize}>-</span>
      </div> : <span className="cart-button fa fa-shopping-cart" onClick={minimize} style={{paddingRight: 5}}></span>}
    </div>
    {p.length === 0 ? <div className="cart-body" style={{display: minimized ? 'none' : 'block' }}>
      <div className="cart-empty">Empty Cart</div>
    </div> : <div>
      {p}
    </div>}
    <div style={{textAlign: 'center', padding: 10}}>
      <a className="btn btn-default" href="/cart"><span className="fa fa-cart"></span>Checkout</a>
    </div>
  </div> : <div />;
}

export {Cart}
